import { useExperience } from '@mc/experience'
import { useBucket, useExperimentVariables } from '@mc/experiments-react'
import { BrandKey } from '../utils'

interface ChatAvailability {
  isDecagonEnabled: boolean
  isDecagonAvailableForBrand: boolean
  shouldUseDecagon: boolean
  shouldUseGladly: boolean
  isReady: boolean
}

export const useChatAvailability = (brandKey?: BrandKey): ChatAvailability => {
  const isDecagonEnabled =
    useBucket('dais-2248-decagon-ai-chat-in-help-center') === 'on'

  const { brands: enabledByBrand } = useExperimentVariables(
    'dais-2248-decagon-ai-chat-in-help-center',
  )

  const { isReady: isExperienceReady, isEnterprise } = useExperience()

  const isDecagonAvailableForBrand = brandKey
    ? (enabledByBrand as Record<BrandKey, boolean>)?.[brandKey] ?? false
    : true

  const shouldUseDecagon =
    isExperienceReady &&
    isDecagonEnabled &&
    !isEnterprise &&
    isDecagonAvailableForBrand

  const shouldUseGladly =
    isExperienceReady &&
    (!isDecagonEnabled || isEnterprise || !isDecagonAvailableForBrand)

  return {
    isDecagonEnabled,
    isDecagonAvailableForBrand,
    shouldUseDecagon,
    shouldUseGladly,
    isReady: isExperienceReady,
  }
}
